module.exports = __webpack_public_path__ + "static/media/remainder.f7d7c2ee.svg";